import {
  EmptyInput,
  InputGroup,
  InputGroupBreak,
  InputRow,
  ModelNewNumericInput,
  RadioListInput,
} from '@equifinance/shared';
import Section from '../Account/components/Section';
import { PropertyValueType, useProductsContext } from '../../contexts';

export default function PropertyValue() {
  const { productLoanDetails } = useProductsContext();
  const { property, errors, warnings } = productLoanDetails;

  return (
    <Section
      id={property?.id}
      title="Property Value"
      level={1}
      errors={errors}
      warnings={warnings}
      titleIcon={<></>}
    >
      <InputGroup>
        <InputRow>
          {property?.passesValuationCriteria && (
            <ModelNewNumericInput
              label="Based on AVM"
              field="property.propertyValue"
              prefix="£"
              isFixedDecimal
              required
              disabled
              maxCharacters={10}
            />
          )}
          <ModelNewNumericInput
            label={property?.passesValuationCriteria !== null
              ? "Based on Applicant's estimate"
              : 'Property value'}
            field="property.estimatedPropertyValue"
            prefix="£"
            isFixedDecimal
            required
            maxCharacters={10}
          />

          {!property?.passesValuationCriteria && (
            <EmptyInput />
          )}
        </InputRow>
      </InputGroup>

      {property?.passesValuationCriteria && (
        <>
          <InputGroupBreak />

          <InputGroup>
            <InputRow>
              <RadioListInput
                field="property.propertyValueType"
                label="Which property value would you like to continue with"
                options={PropertyValueType}
                required
                labelOverride={{
                  'BasedOnAvm': 'AVM',
                  'BaseOnEstimateOfApplicant': "Applicant's estimate",
                }}
              />
              <EmptyInput />
            </InputRow>
          </InputGroup>
        </>
      )}
    </Section>
  );
}
